import { Button } from '@/components/ui/button'
import { InfoNotice } from '@/components/patterns/info-notice'
import { usePathHelper } from '@/hooks/usePathHelper'
import { getPosCartResumeLink } from '@/lib/pos/cart-links'
import { useRecoverablePosCartSummary } from '@/lib/services/carts/carts.query'
import { AlertCircle } from 'lucide-react'
import { useNavigate } from '@tanstack/react-router'

type RecoverablePosCartBannerProps = {
  currentCartId?: Parameters<typeof useRecoverablePosCartSummary>[0]
  orgId: string | number
}

export function RecoverablePosCartBanner({ currentCartId, orgId }: RecoverablePosCartBannerProps) {
  const navigate = useNavigate()
  const pathHelper = usePathHelper()
  const hasActiveCartContext = Boolean(Number(currentCartId ?? 0))
  const { data: summary } = useRecoverablePosCartSummary(currentCartId, {
    orgId,
    enabled: !hasActiveCartContext,
  })

  if (hasActiveCartContext || !summary?.count) {
    return null
  }

  const handleResumeCart = () => {
    void navigate({
      ...getPosCartResumeLink(pathHelper, { orgId, cartId: summary.latest_cart_id }),
      ignoreBlocker: true,
      replace: true,
    })
  }

  return (
    <InfoNotice
      className="mb-4"
      title={`${summary.count} unfinished POS ${summary.count === 1 ? 'cart has' : 'carts have'} payments attached`}
      tone="warning"
      icon={<AlertCircle />}
      action={
        <Button type="button" onClick={handleResumeCart} variant="secondary">
          {summary.count === 1 ? 'Resume Cart' : 'Resume Latest Cart'}
        </Button>
      }
    >
      Resume {summary.count === 1 ? 'this cart' : 'the latest cart'} to complete the order, return
      the payment, or save it as a draft.
    </InfoNotice>
  )
}

export default RecoverablePosCartBanner
